import {connect} from 'react-redux';
import RoutesScreen from '../../components/screens/RoutesScreen';

const mapStateToProps = state => {
  return {
    roles: state.authorization.roles
  }
};

const RoutesScreenContainer = connect(
  mapStateToProps,
    null
)(RoutesScreen);

export default RoutesScreenContainer;